/* eslint-disable react-hooks/exhaustive-deps */
import axios, { AxiosResponse } from "axios";
import { Chips } from "primereact/chips";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../components/loader";
import { APIResponseEntity } from "../../../interface/apiResponse.interface";
import { GetAllAlbumsWithTheirPhotosRespPhotosEntity, ImageNameAndURL, SignInReqEntity, UserInfoEntity } from "../../../interface/libraryGallery.interface";
import { APIGetAlbumLocation, APIGetUserInfoFromToken, APISignInUser } from "../../../service/axios.service";
import { getLocalStorageItem, getSessionStorageItem, removeSessionStorageItem, setLocalStorageItem, setSessionStorageItem } from "../../../service/storage-service";
import { BulkActionsEntity, JB_GLASS_AUTH_TOKEN, JB_GLASS_REMEMBER_ME_DATA, JB_GLASS_USER_INFO, toastOptObj } from "../../../utils/constants";
import { IsNullOrEmptyArray, IsNullOrUndefined, IsStringNullEmptyOrUndefined } from "../../../utils/nullCheck";
import { ALPHABET_NUMBER_SPACE_PATTERN, EMAIL_PATTERN, NOT_ALLOW_SPACE } from "../../../utils/pattern";
import { checkActionAuthorization, checkValidInputOnKeyDown, getFileFromURL, IsFormValid, removeSpaceOnFirstCharacter } from "../../../utils/shared.service";
import LibraryGallery from "./libraryGallery";

declare var $: any;

function LibraryWrapper() {

  const [CheckedAll, setCheckedAll] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [showPassword, setShowPassword] = useState<boolean>(false);

  const [userData, setUserData] = useState<UserInfoEntity | null>(null);
  const [signResp, setSignResp] = useState<APIResponseEntity | null>(null);

  const [rememberMe, setRememberMe] = useState<boolean | null>(null);

  const [formValues, setFormValues] = useState<SignInReqEntity>({
    userId: '',
    password: '',
    signInFrom: 'website'
  });

  const [formErrors, setFormErrors] = useState<SignInReqEntity>({
    userId: 'Please enter email address',
    password: 'Please enter password'
  });

  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  const [photos, setPhotos] = useState<[] | GetAllAlbumsWithTheirPhotosRespPhotosEntity[]>([]);

  const [searchText, setSearchText] = useState<string>("");

  const [bulkSearchTexts, setBulkSearchTexts] = useState<string[] | undefined | null>(undefined);

  const [breadcrumbItems, setBreadcrumbItems] = useState<string[]>([]);

  const [searchresults, setSearchresults] = useState<string>('');

  const [ids, setIds] = useState<[]>([]);

  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const paramAlbumId: string | null = params.get('albumId');
  const paramUserToken: string | null = params.get('userToken');

  const fetchDefaultData = async (): Promise<void> => {
    setIsLoading(true);
    if (paramAlbumId && !IsStringNullEmptyOrUndefined(paramAlbumId)) {
      const resp: AxiosResponse<APIResponseEntity> = await APIGetAlbumLocation(paramAlbumId);
      setIsLoading(false);

      if (!resp || resp.status !== 200 || !resp.data) {
        toast.error(resp.data.message, { ...toastOptObj });
        return;
      }

      const axiosResp: APIResponseEntity = resp.data;

      if (axiosResp.statusCode !== 200 || !axiosResp.data) {
        toast.error(axiosResp.message || axiosResp.errorMsg, { ...toastOptObj });
        return
      }

      const data = resp.data.data;

      setBreadcrumbItems(data.location.split(" / "))
      setIds(data.ids)
    }
  };

  useEffect(() => {
    const fetchDefaultData = async (): Promise<void> => {
      await fetchUserInfoFromUserParamToken();
    };

    fetchDefaultData();
  }, [paramUserToken]);

  useEffect(() => {
    const fetchDefaultData1 = async () => {
      if (paramAlbumId && !IsStringNullEmptyOrUndefined(paramAlbumId)) {
        await fetchDefaultData();
      }
      else {
        setBreadcrumbItems([])
      }
    }
    fetchDefaultData1();

  }, [paramAlbumId]);

  const handleChange = (fieldName: string, value: any) => {
    switch (fieldName) {
      case 'userId': {
        const isValid: boolean = EMAIL_PATTERN.test(value);
        setFormErrors({
          ...formErrors, [fieldName]:
            IsStringNullEmptyOrUndefined(value) ? 'Please enter email address' :
              !isValid ? 'Please enter valid email address' : ''
        });
        break;
      }
      case 'password': {
        // const isValid: boolean = PASSWORD_PATTERN.test(value);
        setFormErrors({
          ...formErrors, [fieldName]:
            IsStringNullEmptyOrUndefined(value) ? 'Please enter password' :
              // !isValid ? 'Enter password from 8 to 32 characters with at least 1 lowercase, 1 uppercase, 1 numeric and 1 special character' :
              ''
        });
        break;
      }
      default:
        break;
    };
    setFormValues({ ...formValues, [fieldName]: value });
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsFormSubmitted(true);
    const isValid = IsFormValid(formErrors);

    if (isValid) {
      setIsFormSubmitted(false);

      setIsLoading(true);
      const resp: AxiosResponse<APIResponseEntity> = await APISignInUser(formValues);
      setIsLoading(false);

      if (resp && resp.data && resp.status === 200) {
        const axiosResp: APIResponseEntity = resp.data;
        if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {

          setSignResp(axiosResp)
          // const isUserLoggedInFirstTime = axiosResp.data.data.isUserLoggedInFirstTime;

          // if (!isUserLoggedInFirstTime) {
          //   setFirstLogin(!isUserLoggedInFirstTime);

          // }
          // else {
          setSessionStorageItem(JB_GLASS_USER_INFO, JSON.stringify(axiosResp.data.data));
          setSessionStorageItem(JB_GLASS_AUTH_TOKEN, axiosResp.data.data.token);

          //storeLoginCredentialsData();

          toast.success(axiosResp.message, { ...toastOptObj });
          setSearchText("");
          $("#exampleModalCenter").modal("hide")

          // }
        } else {
          toast.error(axiosResp.message, { ...toastOptObj });
        }
      }

      if (axios.isAxiosError(resp) && resp.response) {
        // console.log(resp.response);
      }
    };
  };

  const fetchUserInfoFromUserParamToken = async (): Promise<void> => {
    try {
      console.log(`Param User Token >> ${paramUserToken}`);

      if (!paramUserToken || IsStringNullEmptyOrUndefined(paramUserToken)) { return; }

      setIsLoading(true);
      const resp: AxiosResponse<APIResponseEntity> = await APIGetUserInfoFromToken(paramUserToken);
      setIsLoading(false);

      console.log(resp);

      if (resp && resp.data && resp.status === 200) {
        const axiosResp: APIResponseEntity = resp.data;
        if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
          setSignResp(axiosResp);
          setSessionStorageItem(JB_GLASS_USER_INFO, JSON.stringify(axiosResp.data.data));
          setSessionStorageItem(JB_GLASS_AUTH_TOKEN, axiosResp.data.data.token);
        } else {
          toast.error(axiosResp.message, { ...toastOptObj });
        }
      }
    } catch (error: any) {
      setIsLoading(false);

      console.log(error.response);

      let message = "A small error has occurred, causing an interruption of service. Please try again";

      if (error && error.response) {
        const errResp: AxiosResponse = error.response;

        if (errResp && errResp.data && !errResp.data.status) {
          message = errResp.data && errResp.data.statusCode && errResp.data.statusCode === 400
            ? errResp.data.message : error.response.data.message;
        }
        toast.error(message, { ...toastOptObj });
      }
    }
  };

  const handlePhotosUpdate = (photos: GetAllAlbumsWithTheirPhotosRespPhotosEntity[], totalCount: number) => {
    if (IsNullOrUndefined(bulkSearchTexts) || (bulkSearchTexts && !IsNullOrUndefined(bulkSearchTexts) && IsNullOrEmptyArray(bulkSearchTexts))) {
      setSearchresults('');
    } else {
      setSearchresults(`Search results (${totalCount})`);
    }
    setPhotos(photos);
  };

  const storeLoginCredentialsData = (): void => {
    if (!IsNullOrUndefined(rememberMe)) {
      if (rememberMe) {
        setLocalStorageItem(JB_GLASS_REMEMBER_ME_DATA, JSON.stringify({ userId: formValues.userId, password: formValues.password }));
      } else {
        localStorage.removeItem(JB_GLASS_REMEMBER_ME_DATA);
      }
    }
  };

  const markedChecked = (): number => {
    return photos.filter((item: GetAllAlbumsWithTheirPhotosRespPhotosEntity) => item.isChecked).length;
  };

  const bulkAction = async (feature: string): Promise<void> => {
    switch (feature) {
      case BulkActionsEntity.download:
        setIsLoading(true);

        const filteredArray: ImageNameAndURL[] = photos.filter(item => item.isChecked).map(item => ({ filePath: item.filePath, displayFileName: item.displayFileName }));

        const worker = new Worker(new URL("../../../workers/zipWorkers.ts", import.meta.url), { type: "module" });
        worker.postMessage({ images: filteredArray });

        worker.onmessage = (event: MessageEvent<{ success: boolean; zipBlob?: Blob; error?: string }>) => {
          const { success, zipBlob, error } = event.data;

          if (success && zipBlob) {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(zipBlob);
            const albumName: string = breadcrumbItems.length > 0 ? breadcrumbItems[breadcrumbItems.length - 1] : 'images';
            link.download = albumName + '.zip'
            link.click();
          } else {
            toast.error("Failed to generate ZIP: " + (error || "Unknown error"), { ...toastOptObj });
          }

          worker.terminate();
        };
        setIsLoading(false);
        break;

      case BulkActionsEntity.share:
        try {
          const filteredArray: ImageNameAndURL[] = photos.filter(item => item.isChecked).map(item => ({
            filePath: item.filePath,
            displayFileName: item.displayFileName
          }));

          console.log(filteredArray, 'filteredArray');

          if (filteredArray.length > 10) {
            toast.error("Max 10 Images are shareable", { ...toastOptObj });
            return;
          }

          const filePromises = filteredArray.map((item: ImageNameAndURL) => getFileFromURL(item.filePath, item.displayFileName));
          const files = await Promise.all(filePromises);

          if (!navigator.canShare || !navigator.canShare({ files })) {

            // toast.error("This device/browser does not support file sharing.", { ...toastOptObj });
            const hiddenButton = document.createElement("button");
            hiddenButton.style.display = "none";
            hiddenButton.onclick = getMultipleImageURL.bind(null, filteredArray.map((item) => item.filePath));
            document.body.appendChild(hiddenButton);
            hiddenButton.click();
            document.body.removeChild(hiddenButton);
            (window as any).flutter_inappwebview.callHandler('getMultipleImageURL', filteredArray.map((item) => item.filePath));
            return;
          }

          const sizes = files.map(file => ({ name: file.name, size: file.size }));

          console.log(sizes, 'sizes');
          const totalSize = files.reduce((acc, file) => acc + file.size, 0);
          console.log(`Total Size: ${totalSize} bytes`);

          await navigator.share({
            files: files,
          });

          console.log("Files shared successfully!");
        } catch (error) {
          // const errorMessage = (error as Error).message || "";

          //   if (errorMessage.includes("AbortError") || errorMessage.includes("canceled")) {
          //       console.log("User canceled the share action.");
          //       return;
          //   }

          // toast.error("Error during sharing", { ...toastOptObj });
          console.error("Error during sharing:", error);
        }
        break;


      default:
        break;
    }
  }

  // const handleInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSearchText(event.target.value);
  // };

  const rememberMeValidation = (): void => {
    const rememberMeData: string | null = getLocalStorageItem(JB_GLASS_REMEMBER_ME_DATA);
    if (rememberMeData && !IsStringNullEmptyOrUndefined(rememberMeData)) {
      const data = JSON.parse(rememberMeData);
      setFormValues({ userId: data.userId, password: data.password, signInFrom: 'website' });
      setFormErrors({ userId: '', password: '' });
      setRememberMe(true);
    } else {
      setRememberMe(false);
    }
  }

  const handleSignOut = (): void => {
    removeSessionStorageItem(JB_GLASS_USER_INFO);
    removeSessionStorageItem(JB_GLASS_AUTH_TOKEN);
    setFormValues({
      userId: '',
      password: '',
      signInFrom: 'website'
    });
    setFormErrors({
      userId: 'Please enter email address',
      password: 'Please enter password'
    });
    setUserData(null);
    setSearchText("");
    toast.success('User Sign-out successfully', { ...toastOptObj });

  }

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const userStr: string | null = getSessionStorageItem(JB_GLASS_USER_INFO)

      if (userStr && !IsStringNullEmptyOrUndefined(userStr)) {
        const userInfo: UserInfoEntity = JSON.parse(userStr);
        setUserData(userInfo);
        storeLoginCredentialsData();
      }
    };
    fetchData();
  }, [signResp]);

  const handleNavigation = (albumId: string | undefined) => {
    if (albumId) {
      navigate(`/library?albumId=${albumId}`);
    }
  };

  const getMultipleImageURL = (urlList: string[]): string[] => {
    const results: string[] = urlList;
    console.log("Images URL List :- ", results);
    return results;
  }

  return (
    <>
      <Loader isLoading={isLoading} />

      <section className="librariesWrapper py-100" id='scrollable-div'>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-3">

              {userData && !IsNullOrUndefined(userData) ?
                <div className="d-flex justify-content-between">
                  <div className="librarieTitleHldr d-flex justify-content-start">
                    <h1>
                      <span className="hello txt-gray">Hello,</span> {userData.userFullName}
                    </h1>
                  </div>
                  <div className="librarieTitleHldr d-flex justify-content-end">
                    <p className="btn btn-black-border1" onClick={() => handleSignOut()}>
                      Sign out
                    </p>
                  </div>
                </div>
                :
                <div className="librarieTitleHldr d-flex justify-content-end">
                  <p className="btn btn-black-border1" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" onClick={() => rememberMeValidation()}>
                    Sign in for Gallery
                  </p>
                </div>
              }

              <nav>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item cursor-pointer"
                    onClick={() => { setSearchresults(''); setSearchText(''); navigate(`/library`) }}
                  >
                    <span>Home</span>
                  </li>
                  {IsStringNullEmptyOrUndefined(searchresults) && breadcrumbItems.map((item, index) => (
                    <li
                      key={ids[index] || index}
                      className={`breadcrumb-item ${index === breadcrumbItems.length - 1 ? "active" : ""}`}
                      onClick={() => handleNavigation(ids[index])}
                      style={{ cursor: index === breadcrumbItems.length - 1 ? "default" : "pointer", fontWeight: index === breadcrumbItems.length - 1 ? "500" : "900" }}
                    >
                      {index === breadcrumbItems.length - 1 ? (
                        item
                      ) : (
                        <span>{item}</span>
                      )}
                    </li>
                  ))}
                  {
                    !IsStringNullEmptyOrUndefined(searchresults) &&
                    <li className={`breadcrumb-item`}>
                      <span>{searchresults}</span>
                    </li>
                  }
                </ol>
              </nav>

              <div className="searchHldr">
                <div className="libraryChipsSearchMain d-flex flex-column">
                  <i className="bi bi-search"></i>
                  <Chips
                    value={bulkSearchTexts && !IsNullOrEmptyArray(bulkSearchTexts) ? bulkSearchTexts : undefined}
                    onChange={(e) => setBulkSearchTexts(e.value)} onKeyDown={(event: any) => {
                      checkValidInputOnKeyDown(
                        event,
                        ALPHABET_NUMBER_SPACE_PATTERN,
                      );
                      removeSpaceOnFirstCharacter(event);
                    }} max={10}
                    className="libraryChipsSearch" placeholder="Search with keywords..."
                  />
                  <i className="bi bi-x-circle cursor-pointer" onClick={() => setBulkSearchTexts(undefined)}></i>
                  <small className="text-secondary mt-1">Press "Enter" to add new keyword</small>
                </div>

                {/* <div style={{ border: "1px solid", display: "flex" }}>
                  <div className="searchMain">
                    <i className="bi bi-search"></i>
                    <div className="d-flex">
                      <input
                        type="text"
                        name="query"
                        value={searchText}
                        placeholder="Search"
                        title="Enter search keyword"
                        onChange={handleInputChange}
                        className="searchInput"
                        style={{ borderRadius: 0, border: 0, width: "85%" }}
                      />
                      <img src="assets/images/cross-icon.svg" style={{ cursor: 'pointer' }} className="me-1 searchClose" alt="cross-icon" onClick={() => setSearchText("")} />
                    </div>
                  </div>
                </div> */}

                {
                  photos && !IsNullOrUndefined(photos) && !IsNullOrEmptyArray(photos) &&
                  <div className="rightHldr">
                    {
                      (
                        checkActionAuthorization("upgrade", "Access to download photos") ||
                        checkActionAuthorization("upgrade", "Access to share photos")
                      ) &&
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="gridCheck1"
                          checked={photos.filter(item => item.isChecked).length === photos.length}
                          onChange={() => setCheckedAll(!CheckedAll)}
                        />
                        <label
                          className="form-check-label libraryLabel"
                          htmlFor="gridCheck1"
                        >
                          Select All
                        </label>
                      </div>
                    }
                    {
                      (markedChecked() > 0) &&

                      <div className="btnMain">
                        {
                          checkActionAuthorization("upgrade", "Access to download photos") &&
                          <span className="btn btn-gradent me-3"
                            onClick={() => { bulkAction(BulkActionsEntity.download); }}>
                            {`Download (${markedChecked()})`}
                          </span>
                        }

                        {
                          checkActionAuthorization("upgrade", "Access to share photos") &&
                          <span className="btn btn-black" onClick={() => { bulkAction(BulkActionsEntity.share) }}>
                            {`Share (${markedChecked()})`}
                          </span>
                        }
                      </div>
                    }
                  </div>
                }

              </div>

              {
                checkActionAuthorization("upgrade", "Access to share photos") && photos && !IsNullOrUndefined(photos) && !IsNullOrEmptyArray(photos.filter(item => item.isChecked)) && (photos.filter(item => item.isChecked)).length > 10 &&
                <div className="d-flex justify-content-end mt-1">
                  <span style={{ fontSize: "12px", fontWeight: "800" }}>
                    Max 10 Images are shareable.
                  </span>
                </div>
              }

            </div>

            <LibraryGallery signResp={signResp} userData={userData} CheckedAll={CheckedAll} onPhotosUpdate={handlePhotosUpdate} searchText={bulkSearchTexts} breadcrumbItems={breadcrumbItems.join(" / ")} />
          </div>
        </div>
      </section >


      <div className="modal fade" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="content-wrapper d-flex align-items-center auth p-0">
              <div className="row w-100 mx-0">
                <div className="modal-header" style={{ border: "0" }}>
                  <div className="brand-logo" style={{ width: "100%" }}>
                    <img src="assets/images/logo.png" alt="logo" />
                    <p className='modelHeading'> Hello! let's get started</p>
                    <p className="modelTitle">Sign in to continue.</p>
                  </div>
                </div>

                <div className="modal-body px-4">
                  <div className="col-lg-4 w-100 d-flex align-items-center">
                    <div className="auth-form-light text-left  w-100">
                      <form className="" autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
                        <div className="form-group">
                          <label className="form-label">
                            EMAIL ADDRESS
                          </label>
                          <div className="input-group pwd-input-grp d-block">
                            <input type="text" style={{ width: "100%" }} className="form-control form-control-lg"
                              placeholder="Enter your email address" maxLength={50} name='userId' value={formValues.userId}
                              onChange={(e) => handleChange(e.target.name, e.target.value)}
                              onKeyDown={(event: any) => {
                                removeSpaceOnFirstCharacter(event);
                              }} />
                            {
                              isFormSubmitted &&
                              <small className="text-danger font-weight-500">
                                {formErrors.userId}
                              </small>
                            }
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label"> PASSWORD </label>
                          <div className="input-group pwd-input-grp">
                            <input type={showPassword ? 'text' : 'password'} style={{ width: "100%" }} className="form-control form-control-lg" maxLength={30} name='password' value={formValues.password}
                              onChange={(e) => handleChange(e.target.name, e.target.value)}
                              onKeyDown={(event: any) => {
                                checkValidInputOnKeyDown(event, NOT_ALLOW_SPACE);
                                removeSpaceOnFirstCharacter(event);
                              }} />
                            <span className="toggle-visibility cursor-pointer" style={{ zIndex: '999' }}>
                              <img src={showPassword ? 'assets/images/eye-slash.svg' : 'assets/images/eye.svg'} alt="eye" onClick={() => { if (!IsStringNullEmptyOrUndefined(formValues.password)) { setShowPassword(!showPassword) } }} />
                            </span>


                          </div>
                          {isFormSubmitted &&
                            <small className="text-danger font-weight-500 ">
                              {formErrors.password}
                            </small>}

                          <div className="checkBoxMain mt-4 " style={{ display: "flex" }}>
                            <input className="form-check-input me-2" type="checkbox" style={{ width: "1.2rem", height: "1.2rem", marginTop: "0" }}
                              onChange={e => setRememberMe(e.target.checked)} checked={rememberMe ? rememberMe : false}
                            />
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <label className="form-label">REMEMBER ME</label>

                            </div>
                          </div>
                        </div>

                        <div className="mt-3">
                          <button className="btn btn-black-border1 w-100" type="submit">
                            SIGN IN
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LibraryWrapper;
